import EventEmitter from "./EventEmitter";

export default class Time extends EventEmitter
{
  constructor()
  {
    super();

    this.start = Date.now();
    this.current = this.start;
    this.elapsed = 0;
    this.delta = 16.666;

    window.requestAnimationFrame(() =>
    {
      this.tick();
    });
  }

  tick()
  {
    //TODO: Date.now() → ミリ秒（1000 = 1秒）, clock.getElapsedTime() → 秒（1.000 = 1秒）
    const currentTime = Date.now();
    this.delta = currentTime - this.current;
    //NOTE: msを 秒数に変換
    this.elapsed = (currentTime - this.start) * 0.001;
    this.current = currentTime;

    // イベントの発火
    this.trigger('tick');

    // 次のフレームをリクエスト
    window.requestAnimationFrame(() =>
    {
      this.tick();
    });
  }
}
